import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { DpeTileStep, } from '@as-react/common-types';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import DpeValidator from '../dpe-validator/DpeValidator';
import { HtmlInclude } from '../../common/html-include/HtmlInclude';
import { Button, Box, Text, TextSize } from '@as/cotopaxi';
const DpeTile = ({ isPopup, isAuthenticated, data, digitalPartner, onConfirmationClick, onActiveStepChange, onFormValidationError, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.dpe);
    const [active, setActive] = useState(isAuthenticated ? DpeTileStep.VALIDATION : DpeTileStep.INTRO);
    const [isAuth, setIsAuth] = useState(false);
    useEffect(() => {
        if (isAuthenticated && isAuthenticated !== isAuth) {
            setActive(DpeTileStep.VALIDATION);
            setIsAuth(true);
        }
    }, [isAuthenticated]);
    const setActiveStep = (stepToSet) => {
        if (stepToSet !== active) {
            onActiveStepChange({
                from: active,
                to: stepToSet,
            });
            setActive(stepToSet);
        }
    };
    const handleIntroButtonClick = () => {
        setActiveStep(DpeTileStep.VALIDATION);
    };
    const renderIntro = () => (_jsx(Box, { mobile: {
            spacing: {
                paddingTop: 0,
                paddingBottom: 4,
                paddingLeft: 2,
                paddingRight: 2,
            },
        }, tablet: {
            spacing: {
                paddingLeft: 4,
                paddingRight: 4,
            },
        }, children: isPopup ? (_jsx(Text, { size: TextSize.SMALL, children: _jsx(HtmlInclude, { htmlFragment: data.introductionMessage }) })) : (_jsxs(_Fragment, { children: [_jsx(Text, { size: TextSize.SMALL, children: _jsx(HtmlInclude, { htmlFragment: data.shortIntroductionMessage }) }), _jsx(Button, { text: t('dpe.activateNow'), onClick: handleIntroButtonClick })] })) }));
    const renderValidation = () => (_jsxs(_Fragment, { children: [_jsx(Box, { mobile: {
                    spacing: {
                        paddingBottom: 2,
                        paddingLeft: 2,
                        paddingRight: 2,
                    },
                }, tablet: {
                    spacing: {
                        paddingBottom: 3,
                        paddingLeft: 4,
                        paddingRight: 4,
                    },
                }, children: _jsx(Text, { size: TextSize.SMALL, children: _jsx(HtmlInclude, { htmlFragment: data.validationMessage }) }) }), _jsx(Box, { mobile: {
                    spacing: {
                        paddingBottom: 2,
                        paddingLeft: 2,
                        paddingRight: 2,
                    },
                }, tablet: {
                    spacing: {
                        paddingBottom: 4,
                        paddingLeft: 4,
                        paddingRight: 4,
                    },
                }, children: _jsx(DpeValidator, { digitalPartner: digitalPartner, onValidationSuccess: () => setActiveStep(DpeTileStep.CONFIRMATION), onValidationError: errorMessage => {
                        onFormValidationError(Object.assign({}, errorMessage));
                    } }) })] }));
    const renderConfirmation = () => (_jsxs(Box, { mobile: {
            spacing: { paddingBottom: 2, paddingLeft: 2, paddingRight: 2 },
        }, tablet: {
            spacing: { paddingBottom: 4, paddingLeft: 4, paddingRight: 4 },
        }, children: [_jsx(Text, { size: TextSize.SMALL, children: _jsx(HtmlInclude, { htmlFragment: data.confirmationMessage }) }), isPopup && (_jsx(Box, { mobile: {
                    spacing: { paddingTop: 2 },
                }, children: _jsx(Button, { text: t('dpe.continue'), onClick: onConfirmationClick }) }))] }));
    const renderStep = () => {
        switch (active) {
            case DpeTileStep.INTRO:
                return renderIntro();
            case DpeTileStep.VALIDATION:
                return renderValidation();
            case DpeTileStep.CONFIRMATION:
                return renderConfirmation();
            default:
                return null;
        }
    };
    return renderStep();
};
export default DpeTile;
